import { useInView, useCounter } from "@/hooks/useAnimations";
import { Users, Star, Clock, Shield } from "lucide-react";

function StatItem({ icon: Icon, end, suffix, label, color, bg }) {
  const [ref, isInView] = useInView();
  const count = useCounter(end, 2000, isInView);

  return (
    <div ref={ref} className="text-center group" data-testid={`stat-${label.toLowerCase().replace(/\s/g, '-')}`}>
      <div className={`h-14 w-14 ${bg} rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300`}>
        <Icon className={`h-7 w-7 ${color}`} />
      </div>
      <div className="font-['Manrope'] text-4xl sm:text-5xl font-extrabold text-slate-900 tracking-tight">
        {count}{suffix}
      </div>
      <p className="text-sm sm:text-base text-slate-500 mt-2 font-medium">{label}</p>
    </div>
  );
}

const stats = [
  { icon: Users, end: 500, suffix: "+", label: "Beratene Familien", color: "text-cyan-700", bg: "bg-cyan-50" },
  { icon: Star, end: 100, suffix: "%", label: "Kostenübernahme", color: "text-green-600", bg: "bg-green-50" },
  { icon: Clock, end: 48, suffix: "h", label: "Schnelle Termine", color: "text-cyan-700", bg: "bg-cyan-50" },
  { icon: Shield, end: 10, suffix: "+", label: "Jahre Erfahrung", color: "text-green-600", bg: "bg-green-50" },
];

export default function StatsSection() {
  const [ref, isInView] = useInView();

  return (
    <section
      ref={ref}
      data-testid="stats-section"
      className="py-16 lg:py-20 bg-white border-y border-slate-100"
      aria-label="Unsere Zahlen"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className={`grid grid-cols-2 md:grid-cols-4 gap-8 lg:gap-12 transition-all duration-700 ${isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          {stats.map((stat, i) => (
            <StatItem key={i} {...stat} />
          ))}
        </div>
      </div>
    </section>
  );
}
